import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PageNumber from './../../../components/atoms/PageNumber';
import LinkedinLogo from '../../../images/linkedin.png';
import EmailLogo from '../../../images/email.png';
import HumanLogo from '../../../images/Composed-By-a-Human-Not-By-AI-Badge-white.png'


const Contact = () => {
    return(
        <section className="contact" id="section2">
            <Container>
                <Row>
                    <Col>
                    <div className="contact">
                        {/* <div className="contact__pagenumber--wrapper">
                            <PageNumber title="contact" count="06" color={true}> </PageNumber>
                        </div> */}
                        <div className="contact__content">
                            <h2 className="contact__title">Contact me</h2>
                            <p className="contact__text">Feel free to contact me! Send me an e-mail or message me on LinkedIn</p>
                        </div>
                        <div className="contact__icons">
                             <a href="mailto:hayenphan@outlook.com" className="contact__link" target="_blank" rel="noopener noreferrer">
                                <div className="contact__info-wrapper">
                                        <img src={EmailLogo} alt="Email" className="contact__icon" />
                                        <p className="contact__info">hayenphan@outlook.com</p>
                                </div>
                            </a>
                            <a href="https://www.linkedin.com/in/hayenphan/" className="contact__link" target="_blank" rel="noopener noreferrer">
                                <div className="contact__info-wrapper">
                                    <img src={LinkedinLogo} alt="LinkedIn" className="contact__icon contact__linkedin" />
                                    <p className="contact__info">in/hayenphan</p>
                                </div>
                            </a>
                        </div>
                        <div className="contact__crafted-by-human">
                            <img src={HumanLogo} alt="Email" className="contact__crafted-by-human-image" />
                        </div>
                        <p className="contact__copyright">© 2026 Hayen Phan. All rights reserved.</p>
                    </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
};

export default Contact;
